import { HistoryLoader } from "./HistoryTable";

export function HistoryView() {
  return (
    <div className="amz-page tight">
      <div className="amz-head">
        <div className="amz-head-text">
          <h1 className="amz-h1">更新履歴</h1>
          <span className="amz-subtext">すべての変更とAmazonへの送信結果</span>
        </div>
      </div>
      <HistoryLoader />
    </div>
  );
}
